import React from 'react';

import { IconSize, SvgIcon } from './SvgIcon';

interface IconProps {
  size: IconSize;
}

const ArrowFilledDown = (props: IconProps): JSX.Element => (
  <SvgIcon size={props?.size}>
    <path d="M7 10L12 15L17 10H7Z" fill="currentColor" />
  </SvgIcon>
);

export default ArrowFilledDown;
